// Creates the DOM elements to show the user autocomplete options
function addAutocompleteMenuToDOM(inputElement, val, librarySearchFunc, { prefix, suggestions }) {
  const userInput = inputElement.value.toLowerCase();

  // Takes care of race condition so that outdated autocomplete items are not inserted
  if (prefix.toLowerCase() !== userInput) {
    return;
  }

  const autocompleteMenu = document.createElement('DIV');
  autocompleteMenu.setAttribute('id', `${inputElement.id}autocomplete-list`);
  autocompleteMenu.setAttribute('class', 'library-autocomplete-items');
  inputElement.parentNode.appendChild(autocompleteMenu);

  // Adds autocomplete options to menu
  suggestions.forEach(suggestion => {
    const matchIndex = suggestion.indexOf(userInput);
    const autocompleteItem = document.createElement('DIV');
    const preMatchItem = document.createElement('STRONG');
    const matchItem = document.createElement('SPAN');
    const postMatchItem = document.createElement('STRONG');
    const hiddenInput = document.createElement('INPUT');

    // Sets up autocomplete suggestion items with some bold text and a hidden input
    preMatchItem.innerText = matchIndex >= 0 ? suggestion.substring(0, matchIndex) : '';
    matchItem.innerText =
      matchIndex >= 0 ? suggestion.substring(matchIndex, matchIndex + userInput.length) : '';
    postMatchItem.innerText =
      matchIndex >= 0 ? suggestion.substring(matchIndex + userInput.length) : suggestion;
    hiddenInput.setAttribute('type', 'hidden');
    hiddenInput.value = suggestion;

    autocompleteItem.appendChild(preMatchItem);
    autocompleteItem.appendChild(matchItem);
    autocompleteItem.appendChild(postMatchItem);
    autocompleteItem.appendChild(hiddenInput);
    // Event listener so users can select autocomplete options
    autocompleteItem.addEventListener('click', function (e) {
      inputElement.value = this.getElementsByTagName('input')[0].value;
      closeAllLists();
      librarySearchFunc(undefined, userInput);
    });
    autocompleteMenu.appendChild(autocompleteItem);
  });
}

// Close all autocomplete lists in the document except for the one passed in
function closeAllLists(inputElement, element) {
  const autocompleteLists = document.getElementsByClassName('library-autocomplete-items');
  for (let i = 0; i < autocompleteLists.length; i++) {
    if (element != autocompleteLists[i] && element != inputElement) {
      autocompleteLists[i].parentNode.removeChild(autocompleteLists[i]);
    }
  }
}

export { addAutocompleteMenuToDOM, closeAllLists };
